module.exports = __webpack_public_path__ + "static/img/u26.a0a010a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kexie/regen/u26.svg
// module id = LdG4
// module chunks = 0